export const TICKETS_MODALS = {
  VER_INFORMACION: 'VER INFORMACION TICKET MODAL',
  VER_CHAT: 'VER CHAT TICKET MODAL',
  DESCARGAR_ARCHIVOS: 'DESCARGAR ARCHIVOS TICKET MODAL',
  ADJUNTAR_ARCHIVOS: 'ADJUNTAR ARCHIVOS TICKET MODAL',
  CERRAR_TICKET: 'CERRAR TICKET MODAL',
  REABRIR_TICKET: 'REABRIR TICKET MODAL',
  CREAR_TICKET: 'CREAR TICKET MODAL',
};

export const MAQUINAS_VIRTUALES_MODALS = {
  VER_INFORMACION: 'VER INFORMACION MAQUINA VIRTUAL MODAL',
  ENCENDER: 'ENCENDER MAQUINA VIRTUAL MODAL',
  APAGAR: 'APAGAR MAQUINA VIRTUAL MODAL',
  SUSPENDER: 'SUSPENDER MAQUINA VIRTUAL MODAL',
  RESTABLECER: 'RESTABLECER MAQUINA VIRTUAL MODAL',
  REINICIAR_SISTEMA_OPERATIVO_INVITADO:
    'REINICIAR SISTEMA OPERATIVO INVITADO MAQUINA VIRTUAL MODAL',
  APAGAR_SISTEMA_OPERATIVO_INVITADO:
    'APAGAR SISTEMA OPERATIVO INVITADO MAQUINA VIRTUAL MODAL',
};

export const TELEFONIA_MODALS = {
  HABILITAR_NUM_BLOQUEADOS: 'HABILITAR NUMEROS BLOQUEADOS',
  DESHABILITAR_NUM_BLOQUEADOS: 'DESHABILITAR NUMEROS BLOQUEADOS',
  HABILITAR_ANI: 'HABILITAR ANI',
  DESHABILITAR_ANI: 'DESHABILITAR ANI',
  CAMBIAR_ESTADO_ANI: 'DESHABILITAR ANI',
  BLOQUEAR_NUMERO: 'BLOQUEAR NUMEROS',
};
export const SMS_NG_MODALS = {
  HABILITAR_CAMPANA: 'HABILITAR CAMPANA',
  PAUSAR_CAMPANA: 'PAUSAR CAMPANA',
  DESHABILITAR_CAMPANA: 'DESHABILITAR CAMPANA',
};
export const USERS_MODALS = {
  PERMISOS_USUARIOS: 'PERMISOS USUARIOS',
  CONTRASENIA: 'CAMBIAR CONTRASENIA',
  EDITAR: 'EDITAR USUARIO',
  HABILITAR_USUARIO: 'HABILITAR USUARIO',
  DESHABILITAR_USUARIO: 'DESHABILITAR USUARIO',
};
